const strawProduct = {
  variations: [
    {
      text: "Straw Bedding Pellets 975kg (£4.08/bag) Full Pallet",
      stripe_price_id: "price_1QX43CDaY5da5KQsuUSea8hv",
      //   stripe_price_id: "price_1Jf4VmDaY5da5KQspj1VKPTi", // test product
      price: "265.00",
    },
    {
      text: "Straw Bedding Pellets 750kg (£4.12/bag) Three Quarter Pallet",
      stripe_price_id: "price_1QX44hDaY5da5KQsZIfez7TE",
      //   stripe_price_id: "price_1Jf4VmDaY5da5KQspj1VKPTi", // test product
      price: "206.00",
    },
    {
      text: "Straw Bedding Pellets 525kg (£4.83/bag) Half Pallet",
      stripe_price_id: "price_1QX45gDaY5da5KQsoQWCUJ7u",
      //   stripe_price_id: "price_1Jf4VmDaY5da5KQspj1VKPTi", // test product
      price: "169.00",
    },
  ],
}
const WoodProduct = {
  variations: [
    {
      text: "Wood Bedding Pellets 975kg (£3.53/bag) Full Pallet",
      stripe_price_id: "", // add id when back in stock price_1JkVABDaY5da5KQsG312QHkb
      price: "Out of stock",
    },
    {
      text: "Wood Bedding Pellets 525kg (£3.82/bag) Half Pallet",
      stripe_price_id: "", // add id when back in stock price_1JeMinDaY5da5KQsKCO0Ayj0
      price: "Out of stock",
    },
  ],
}

export { strawProduct, WoodProduct }
